import { InferType } from 'yup';

import { ILiabilitiesAll } from '@zeta-types';
import { liabilitiesDefault, liabilitiesValidations } from './form-helpers';

export const addLiabilities = (clientLiabilities: any, ffConfig: any) => {
  const liabilitiesConfig = [
    { liabilityType: 'Mortgage' },
    { liabilityType: 'Personal Loans' },
    { liabilityType: 'Credit Card' },
    { liabilityType: 'Car Loan' },
  ];

  const defaultLiability = {
    institution: '',
    originalAmount: 0,
    monthlyPayment: 0,
    paymentFrequency: '',
    startDate: '',
    endDate: '',
    interest: '',
    currentValue: 0,
    collateral: '',
    securedOrNot: '',
    description: '',
  };

  const mapLiability = (liability: any, liabilityType: string) => ({
    id: liability?.id || '',
    liabilityType: liabilityType || liability?.liabilityType,
    institution: liability?.lenderName || '',
    originalAmount: liability?.originalAmount || 0,
    monthlyPayment: liability?.monthlyPayment || 0,
    paymentFrequency: liability?.paymentFrequency || '',
    startDate: liability?.startDate || '',
    endDate: liability?.dueDate || '',
    interest: liability?.interestRate || '',
    currentValue: liability?.outstandingAmount || 0,
    collateral: liability?.collateral || '',
    securedOrNot: liability?.securedUnsecured || '',
    description: liability?.liabilityDescription || '',
    show: (ffConfig?.fields && ffConfig?.fields[liabilityType?.split(' ')?.join('')?.toLowerCase()]?.active) ?? true,
  });

  const additionalLiabilities = liabilitiesConfig.map((config) => {
    const matchedLiability = clientLiabilities.find((liability: any) => liability.liabilityType === config.liabilityType);

    if (matchedLiability) {
      return mapLiability(matchedLiability, config.liabilityType);
    }

    return mapLiability(defaultLiability, config.liabilityType);
  });

  const nonConfiguredLiabilities = clientLiabilities
    .filter((liability: any) => !liabilitiesConfig.some((config) => config.liabilityType === liability.liabilityType))
    .map((liability: any) => mapLiability(liability, liability.liabilityType));

  return [...additionalLiabilities, ...nonConfiguredLiabilities];
};

export const allLiabilitiesTransform = (liabilities: ILiabilitiesAll, ffConfig: any) => {
  return {
    client:
      liabilities?.clientLiability && liabilities?.clientLiability?.length > 0
        ? addLiabilities(liabilities?.clientLiability, ffConfig)
        : liabilitiesDefault(ffConfig),
    partner:
      liabilities?.partnerLiability && liabilities?.partnerLiability?.length > 0
        ? addLiabilities(liabilities?.partnerLiability, ffConfig)
        : liabilitiesDefault(ffConfig),
    joint:
      liabilities?.jointLiability && liabilities?.jointLiability?.length > 0
        ? addLiabilities(liabilities?.jointLiability, ffConfig)
        : liabilitiesDefault(ffConfig),
  };
};

type liabilitiesSingleSchemaType = InferType<typeof liabilitiesValidations>;

export const createLiabilityCapturePartialPayload = (capturedData: liabilitiesSingleSchemaType[]) => {
  const result = capturedData.map((customData: liabilitiesSingleSchemaType) => {
    const liability = {
      id: customData.id,
      liabilityType: customData.liabilityType || undefined,
      liabilityDescription: customData.description || undefined,
      outstandingAmount: customData.currentValue || undefined,
      originalAmount: customData.originalAmount || undefined,
      lenderName: customData.institution || undefined,
      startDate: customData.startDate || undefined,
      dueDate: customData.endDate || undefined,
      interestRate: customData.interest || undefined,
      monthlyPayment: customData.monthlyPayment || undefined,
      paymentFrequency: customData.paymentFrequency || undefined,
      currentValue: customData.currentValue || undefined,
      collateral: customData.collateral || undefined,
      securedUnsecured: customData.securedOrNot || undefined,
    };

    return liability;
  });

  return result;
};
